export default __webpack_public_path__ + "static/media/vehicle-monitoring-compressed.5884dfe8.jpg";